/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { toast } from 'react-hot-toast';
import ajaxStudent from "../../../util/remote/ajaxStudent";
import Loader from "../../Common/Loader";
import SystemModal from "../../Common/SystemModal";
import ajaxStudentGroup from "../../../util/remote/ajaxStudentGroup";
import Select from "react-select";


const AddMissingStudent=(props)=>{

    const [loading, setLoading] = useState(false)
    const [firstName, setFirstName] = useState("");
    const [surname, setSurname] = useState("");
    const [gender, setGender] = useState("");
    const [groupList, setGroupList] = useState(false);
    const [className, setClassName] = useState("");

    useEffect(() => {
            getGroups();
        }, [props.schoolID]);

    const handleUpdate = async(e) =>{
        e.preventDefault()
        if(firstName.length>0 || surname.length>0 ){
            setLoading(true)
            const server_response = await ajaxStudent.addMissingStudent(firstName, surname, gender, props.schoolID, className);
            setLoading(false);
            if(server_response.status==="OK"){
                toast.success(server_response.message);
                props.g();
            }
            else{
                toast.error(server_response.message); 
            }
        }
        else{
            toast.error("Please enter both student names!")
        }  
    }

    const getGroups = async () => {
        const server_response = await ajaxStudentGroup.fetchGroupListUsingSchoolCode(props.schoolID);
        if (server_response.status === "OK") {
        setGroupList(server_response.details);
        } else {
        setGroupList([]);
        }
    };
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleUpdate}>Register<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Add New Student"
            id="model-add-missing-student"
            size="md"
            footer={RenderFooter}
        >
            <div className="row">
                <div className="col-lg-6">
                    <div className="mb-4 form-group border-1">
                        <label htmlFor="">Surname</label>
                        <input onChange={(e)=>setSurname(e.target.value)} placeholder="Enter surname of student..." style={{border: "1px solid grey"}} value={surname} type="text" className="form-control"/>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-4 form-group border-1">
                        <label htmlFor="">First Name</label>
                        <input onChange={(e)=>setFirstName(e.target.value)} placeholder="Enter first name of student..." style={{border: "1px solid grey"}} value={firstName} type="text" className="form-control"/>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="mb-4 form-group border-1">
                        <label htmlFor="">Gender</label>
                        <select
                                style={{border: "1px solid grey"}}
                                className="col-12 form-control"
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}>
                                <option value="">Select..</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-4 form-group border-1">
                        <label htmlFor="">Select Class:</label>
                       <Select
                                onChange={(e) => setClassName(e.group_name)}
                                getOptionLabel={(option) => option.group_name}
                                getOptionValue={(option) => option.group_name}
                                isSearchable
                                options={Array.isArray(groupList) ? groupList : []}
                                value={
                                    Array.isArray(groupList) &&
                                    groupList.find((value) => value.group_name === className)
                                }
                            />
                    </div>
                </div>
            </div>
       
        </SystemModal>
    )
}

export default AddMissingStudent
